export interface ShortcutItem {
  key: string;
  description: string;
}

export interface ShortcutCategory {
  category: string;
  items: ShortcutItem[];
}

export interface ResourceLink {
  title: string;
  url: string;
  description: string;
}

export const isMac = typeof navigator !== 'undefined' && navigator.platform.toLowerCase().includes('mac');

export const KEYBOARD_SHORTCUTS: ShortcutCategory[] = [
  {
    category: 'Selection',
    items: [
      {
        key: 'Drag',
        description: 'Box-select nodes',
      },
      {
        key: isMac ? '⇧ / ⌘ + Click' : 'Shift / Ctrl + Click',
        description: 'Add to selection',
      },
      {
        key: isMac ? '⌘ + A' : 'Ctrl + A',
        description: 'Select all',
      },
      {
        key: 'Esc',
        description: 'Deselect / close',
      },
      {
        key: 'Delete / ⌫',
        description: 'Delete selected',
      },
    ],
  },
  {
    category: 'Edit',
    items: [
      {
        key: isMac ? '⌘ + K' : 'Ctrl + K',
        description: 'Add node / command palette',
      },
      {
        key: 'Arrow Keys',
        description: 'Nudge selected (1px)',
      },
      {
        key: isMac ? '⇧ + Arrows' : 'Shift + Arrows',
        description: 'Nudge selected (10px)',
      },
      {
        key: isMac ? '⌘ + D' : 'Ctrl + D',
        description: 'Duplicate selected',
      },
      {
        key: isMac ? '⌘ + C' : 'Ctrl + C',
        description: 'Copy selected',
      },
      {
        key: isMac ? '⌘ + V' : 'Ctrl + V',
        description: 'Paste',
      },
      {
        key: isMac ? '⌘ + ]' : 'Ctrl + ]',
        description: 'Bring forward',
      },
      {
        key: isMac ? '⌘ + [' : 'Ctrl + [',
        description: 'Send backward',
      },
      {
        key: isMac ? '⌘ + ⇧ + ]' : 'Ctrl + Shift + ]',
        description: 'Bring to front',
      },
      {
        key: isMac ? '⌘ + ⇧ + [' : 'Ctrl + Shift + [',
        description: 'Send to back',
      },
    ],
  },
  {
    category: 'History & View',
    items: [
      {
        key: isMac ? '⌘ + Z' : 'Ctrl + Z',
        description: 'Undo',
      },
      {
        key: isMac ? '⌘ + ⇧ + Z' : 'Ctrl + Shift + Z',
        description: 'Redo',
      },
      {
        key: isMac ? '⌘ + S' : 'Ctrl + S',
        description: 'Save to cloud',
      },
      {
        key: '+  /  -',
        description: 'Zoom in / out',
      },
      {
        key: '0',
        description: 'Fit view',
      },
    ],
  },
];

export const RESOURCE_LINKS: ResourceLink[] = [
  {
    title: 'Guides & Tutorials',
    url: 'https://stacksketch.site/guides',
    description: 'Learn how to use Stack Sketch effectively',
  },
  {
    title: 'Blog',
    url: 'https://stacksketch.site/blog',
    description: 'Latest updates and tips',
  },
  {
    title: 'Documentation',
    url: 'https://stacksketch.site/docs',
    description: 'Detailed API and feature documentation',
  },
];
